
import { Injectable } from '@angular/core';
import { GatewayClientProvider } from '../gateway-client/gateway-client';

/*
  Generated class for the ContactUsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ContactUsProvider {

  constructor(public gateway: GatewayClientProvider) {

  }

  getContactSubject() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getContactSubject()
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  customerComplaint(complaintData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.customerComplaint(complaintData)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getCustomerComplaintByCustomerid(customerid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCustomerComplaintByCustomerid(customerid)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getCustomerMessageByMessageid(customer_messenger) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCustomerMessageByMessageid(customer_messenger)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getUserMessageByMessageid(user_messenger) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getUserMessageByMessageid(user_messenger)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  sendMessageToStaffUser(messageToStaffUser) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.sendMessageToStaffUser(messageToStaffUser)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/contact-us/contact-us.ts